import actions from "./actions"

const initialState = {
    customer: {},
    customers: [],
    customersToAllocate: null
};

export default function customersReducers(state = initialState, action:{payload:any, type: any}):any{
    switch(action.type){
        case actions.SET_CUSTOMERS:
            return {...state, customers: action.payload};
        case actions.SET_CUSTOMER:
            return {...state, customer: action.payload};
        case actions.SET_CUSTOMERS_TO_ALLOCATE:
            return {...state, customersToAllocate: action.payload};
        default:
            return state;
    }
}